import { render, staticRenderFns } from "./AnonymousGifting.vue?vue&type=template&id=8dc8bf2c&scoped=true"
import script from "./AnonymousGifting.vue?vue&type=script&lang=js"
export * from "./AnonymousGifting.vue?vue&type=script&lang=js"
import style0 from "./AnonymousGifting.vue?vue&type=style&index=0&id=8dc8bf2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc8bf2c",
  null
  
)

export default component.exports